export default __webpack_public_path__ + "static/media/options1_2040.8dee3d28.webp";